import { useRouter } from '@abyss/web/hooks/useRouter';
import { V2Alert } from '@abyss/web/ui/Alert';
import find from 'lodash/find';
import { useEffect, useRef } from 'react';

import { useLagoon } from '../../hooks/useLagoon';
import { useCareTeamStore } from '../../store/useCareTeamStore';
import { Constants } from '../Constants';
import { ConstantsLagoon } from '../ConstantsLagoon';
import { ConstantsRoutes } from '../ConstantsRoutes';

export const MaximumProviderLimitBanner = ({
  isCareTeamView = false,
  isMixedResultsPage = true,
}: {
  isCareTeamView: boolean;
  isMixedResultsPage?: boolean;
}) => {
  const bannerRef = useRef<HTMLDivElement>(null);
  const { navigate } = useRouter();
  const { setShowMaximumProviderLimitBanner, showMaximumProviderLimitBanner } =
    useCareTeamStore((state) => ({
      setShowMaximumProviderLimitBanner:
        state.setShowMaximumProviderLimitBanner,
      showMaximumProviderLimitBanner: state.showMaximumProviderLimitBanner,
    }));

  const uiMessaging = useLagoon(Constants.LAGOON_TABLE.UI_MESSAGING)();
  const maximumProviderLimitBanner = find(uiMessaging, {
    key: ConstantsLagoon.UI_MESSAGING.MAXIMUM_PROVIDER_LIMIT_BANNER,
  });
  const allConfigs = useLagoon('config')();
  const maximumProviderLimit = allConfigs?.find(
    (row) => row.key === 'MAXIMUM_PROVIDER_LIMIT_FOR_CARETEAM'
  )?.value;

  useEffect(() => {
    if (showMaximumProviderLimitBanner && bannerRef.current) {
      bannerRef.current.scrollIntoView({ block: 'center' });
    }
  }, [showMaximumProviderLimitBanner]);

  if (!showMaximumProviderLimitBanner) return null;

  return (
    <div
      ref={bannerRef}
      style={{ paddingTop: isMixedResultsPage ? '0px' : '24px' }}
    >
      <V2Alert
        {...(!isCareTeamView && {
          cta: {
            type: 'link',
            props: {
              children: 'Go to Care Team',
              href: '/findcare/care-team',
              onClick: (e: React.MouseEvent) => {
                e.preventDefault();
                navigate(ConstantsRoutes.CARE_TEAM.path);
              },
            },
          },
        })}
        data-testid="maximum-provider-limit-banner"
        onClose={() => setShowMaximumProviderLimitBanner(false)}
        status="info"
        title={maximumProviderLimitBanner?.title}
      >
        {maximumProviderLimitBanner?.message.replace(
          '{providerCount}',
          maximumProviderLimit
        )}
      </V2Alert>
    </div>
  );
};
